import dayjs from 'dayjs'
import { ManagementReport } from './types'

export const addOrUpdateManagementReport = (
  stateManagementReports: Record<string, ManagementReport>,
  managementReportToAdd: ManagementReport
) => {
  const newManagementReports: Record<string, ManagementReport> = {
    ...stateManagementReports
  }
  newManagementReports[
    dayjs(managementReportToAdd.reportDate).utc().format('MM/DD/yyyy')
  ] = managementReportToAdd
  return newManagementReports
}
